var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNews1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9192 4.89033H15.4907M10.9192 7.9831H15.4907M3.34351 11.6154H15.2221M3.34351 14.7599H15.2221M3.34351 17.9039H15.2221M3.34351 3.73926H8.73889V9.13464H3.34351V3.73926Z",
    stroke: "#768AA4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2085 20.6817H3.79156C3.41479 20.6817 3.04171 20.6075 2.69363 20.4633C2.34555 20.3191 2.0293 20.1077 1.76292 19.8413C1.49655 19.5748 1.28528 19.2585 1.14118 18.9104C0.99708 18.5622 0.922975 18.1891 0.923096 17.8124V1.31836H17.34V17.8128",
    stroke: "#768AA4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.077 10.7812H17.3401V17.8128C17.3401 18.5736 17.6423 19.3032 18.1802 19.8411C18.7182 20.379 19.4478 20.6813 20.2085 20.6813C20.9693 20.6813 21.6989 20.379 22.2369 19.8411C22.7748 19.3032 23.077 18.5736 23.077 17.8128V10.7812Z",
    stroke: "#768AA4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews1);
export default __webpack_public_path__ + "static/media/news 1.d0affba9e12d920cfb208213ed69e734.svg";
export { ForwardRef as ReactComponent };